var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Colel"},[_c('div',{staticClass:"p-col-12 p-md-12 p-lg-12"},[(_vm.isAdmin)?_c('postAll',{staticClass:"p-p-2"}):_vm._e(),_c('colelTable',{attrs:{"isRecommendations":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }